import { Component, OnInit } from '@angular/core';

@Component({
  selector: '[tableBodyColumn]',
  templateUrl: './table-body-column.component.html',
  styleUrls: ['./table-body-column.component.css']
})
export class TableBodyColumnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
